import { useEffect, useState } from "react";
import api from "../services/api";


export default function KDS() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    loadItems();
    const timer = setInterval(loadItems, 8000); // auto refresh
    return () => clearInterval(timer);
  }, []);

  const loadItems = async () => {
    try {
      const res = await api.get("/kds/items");
      setItems(res.data);
    } catch (err) {
      console.error("Failed to load KDS items", err);
    }
  };

  const markDone = (itemRowId) => {
  // 1️⃣ Remove from UI immediately
  const removedItem = items.find(i => i.id === itemRowId);
  setItems(prev => prev.filter(i => i.id !== itemRowId));

  // 2️⃣ Call backend in background
  api.post(`/kds/item/${itemRowId}/done`)
    .catch(() => {
      // 3️⃣ Restore if failed
      setItems(prev => [...prev, removedItem]);
      alert("Failed to mark item done");
    });
};


  return (

<>
  
  {/* page content */}


    <div style={{ padding: 20 }}>
      <h2>Kitchen Display System</h2>

      {items.length === 0 ? (
        <p>No pending kitchen items</p>
      ) : (
        <div style={{ padding: 20 }}>
  <h2>Kitchen Display System</h2>

  {items.length === 0 ? (
    <p>No pending kitchen items</p>
  ) : (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
        gap: 16
      }}
    >
      {Object.values(
        items.reduce((acc, item) => {
          if (!acc[item.live_order_id]) {
            acc[item.live_order_id] = {
              order_no: item.order_no,
              order_type: item.order_type,
              items: []
            };
          }
          acc[item.live_order_id].items.push(item);
          return acc;
        }, {})
      ).map(order => (
        <div
          key={order.order_no}
          style={{
            border: "2px solid #333",
            borderRadius: 10,
            padding: 12,
            background: "#fafafa"
          }}
        >
          {/* ORDER HEADER */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 10
            }}
          >
            <div style={{ fontSize: 18, fontWeight: "bold" }}>
              Order #{order.order_no}
            </div>
            <div style={{ fontSize: 14 }}>
              {order.order_type}
            </div>
          </div>

          {/* ITEMS */}
          {order.items.map(i => (
  <div
    key={i.id}
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: "1px dashed #ccc",
      padding: "6px 4px"
    }}
  >
    {/* LEFT: ITEM INFO */}
    <div style={{ flex: 1 }}>
      <span style={{ fontWeight: "bold" }}>
        {i.item_name}
      </span>

      {i.size_name && (
        <span style={{ marginLeft: 6, color: "#555" }}>
          ({i.size_name})
        </span>
      )}

      <span style={{ marginLeft: 10, fontSize: 16 }}>
        × <b>{i.qty}</b>
      </span>
    </div>

    {/* RIGHT: TIME + DONE */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10
      }}
    >
      <span style={{ fontSize: 12, color: "#777" }}>
        {i.minutes_elapsed}m
      </span>

      <button
        onClick={() => markDone(i.id)}
        style={{
          background: "#c62828",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: 32,
          height: 32,
          fontSize: 18,
          cursor: "pointer"
        }}
        title="Mark Done"
      >
        ✖
      </button>
    </div>
  </div>
))}

        </div>
      ))}
    </div>
  )}
</div>

      )}
    </div>
    </>
  );
}
